module.exports = __webpack_public_path__ + "static/FJPG-B85-9b27ac33b6eeb8e8b826bfe0d48bc286.jpg";